export class FilterMenus {
  display = 'filter';
  items: any[];

  constructor() {
    this.items = [];
  }
}
